import { useState } from 'react';
import { useAnswerHistoryQuery } from '../../graphql/answer/history';
import { useQuestionAnswerContributorsQuery } from '../../graphql/question/getQuestionAnswerContributors';
export default function useData(questionID) {
    const [historyQueryState, historyQueryActions] = useAnswerHistoryQuery({
        variables: {
            questionID,
        },
    });
    const [answerContributorsQueryState] = useQuestionAnswerContributorsQuery({
        variables: {
            questionID,
        },
    });
    const [showOnlyDiff, setShowOnlyDiff] = useState(true);
    const state = {
        showOnlyDiff,
        historyQuery: historyQueryState,
        answerContributorsQuery: answerContributorsQueryState,
    };
    const actions = {
        setShowOnlyDiff,
        historyQuery: historyQueryActions,
    };
    return [state, actions];
}
